module.exports = __webpack_public_path__ + "static/img/sf.571b1f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sf.png
// module id = Wdbu
// module chunks = 0